import React from 'react';
import {todayKolkata,validPaymentDay} from '../utils/paymentDates';
const display=day=>new Intl.DateTimeFormat('en-IN',{day:'2-digit',month:'short',year:'numeric',timeZone:'UTC'}).format(new Date(`${day}T00:00:00Z`));
export default function PaymentDateWarning({date}){
 const today=todayKolkata();
 if(!validPaymentDay(date)||date===today)return null;
 return <div role="alert" style={{marginTop:8,padding:'10px 12px',border:'1px solid #b45309',borderRadius:6,background:'#fffbeb',color:'#78350f'}}><strong>Payment date is not today.</strong> Selected: {display(date)}. Today: {display(today)} (Kolkata). This payment will be reported as collected on the selected date. Please verify the date before confirming payment.</div>;
}
